import { MailInboxAddresseeDTO } from "../../models/mail-inbox-addressee/mail-inbox-addressee-dto";
import { MailInboxAddresseeSTO } from "../../models/mail-inbox-addressee/mail-inbox-addressee-sto";
import { BaseApiService } from "../base";

export class MailInboxAddresseesApiService extends BaseApiService<MailInboxAddresseeDTO, MailInboxAddresseeSTO> {
  constructor() {
    super({
      servicePath: "/MailInboxAddressee",
      loadItemsPath: "/GetMailInboxAddressee",
      saveItemsPath: "/SaveMailInboxAddressee",
    });
  }
}
